module.exports = __webpack_public_path__ + "img/rubin_benefit_02_education.010e1f35.svg";